import React, { FormEvent } from 'react';

import classes from './CurrentCardInfo.module.scss';
import { EntityPaymentMethodDetails } from '../../../../../shared/interfaces/entityPaymentMethodDetails';
import { CardDetails } from '../../../../components/CardDetails/CardDetails';
import { stripeService } from '../../../../services/stripeService';

type CurrentCardInfoProps = {
  formId: string;
  entityId: number;
  paymentMethodDetails: EntityPaymentMethodDetails | null;
  onPaymentSuccess: () => void;
};

const CurrentCardInfo = ({
  formId,
  entityId,
  paymentMethodDetails,
  onPaymentSuccess,
}: CurrentCardInfoProps) => {
  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    await stripeService.selfBillingPaymentRetry(entityId);
    onPaymentSuccess();
  };

  return (
    <form id={formId} className={classes.container} onSubmit={handleSubmit}>
      <h5 className={classes.title}>Payment Card</h5>
      <CardDetails paymentMethodDetails={paymentMethodDetails} />
    </form>
  );
};

export { CurrentCardInfo };
